'use client'

import '@/views/digital-banking/digital-banking.css'

import { formatTitleWithItalic, parseCmsHtml } from '@/utils'

function MyAlrajhiImportance({ data }) {
  return (
    <div className="importance">
      <div className="inward-container container">
        <div data-aos="fade-up" data-aos-delay="150">
          <h2 className="heading">Why use MY alrajhi?</h2>
        </div>
        <div className="row my-5 justify-content-center">
          {data?.importance?.map(item => (
            <div
              className="col-12 col-md-4 d-flex flex-column align-items-center mb-4"
              data-aos="fade-up"
              data-aos-delay="150"
              key={item.name}
            >
              <div className="coming-soon-image-container">
                <img
                  src={item?.image || item?.image_link}
                  alt="Shield Icon"
                  className="d-block"
                  width="100%"
                />
              </div>
              <div>
                <h3 className="fw-bold">{formatTitleWithItalic(item.name)}</h3>
                {item.description && <div>{parseCmsHtml(item.description)}</div>}
              </div>
            </div>
          ))}
        </div>
        <iframe
          data-aos="fade-up"
          data-aos-delay="150"
          className="video-player"
          src={data?.whyUseVideoLink}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  )
}

export default MyAlrajhiImportance
